exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.list > a {\n  display: inline-block;\n  width: 100%;\n  height: 44px;\n  font-size: 18px;\n}\n.form label {\n  display: inline-block;\n  width: 100%;\n}\n.form input {\n  border-bottom: 1px solid;\n}", "", {"version":3,"sources":["D:/projects/cn/course_web/projects/self_work/src/common/components/start.vue"],"names":[],"mappings":";AACA;EACE,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,gBAAgB;CACjB;AACD;EACE,sBAAsB;EACtB,YAAY;CACb;AACD;EACE,yBAAyB;CAC1B","file":"start.vue","sourcesContent":["\n.list > a {\n  display: inline-block;\n  width: 100%;\n  height: 44px;\n  font-size: 18px;\n}\n.form label {\n  display: inline-block;\n  width: 100%;\n}\n.form input {\n  border-bottom: 1px solid;\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-37c2092b","scoped":false,"hasInlineConfig":false}!./node_modules/stylus-loader?{"resolve url":true,"import":["D://projects//cn//course_web//projects//self_work//src//theme"],"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/common/components/start.vue
// module id = BA35
// module chunks = 79